import { MF } from "./midFiTokens";

export const SERIES_COLORS: Record<string, string> = {
  Actual: "#22c55e",
  "Prior Period": "#64748b",
  Previous: "#f97316",
  "Historical Average": "#0ea5e9",
  Estimated: "#93c5fd",
  "Projected Data": "#93c5fd",
  "Compare A": "#16a34a",
  "Compare B": "#f59e0b",
  Net: "#6366f1",
};

export interface ISeriesStyle {
  borderColor: string;
  backgroundColor: string;
  borderWidth?: number;
  borderDash?: number[];
}

// Mid-fi series treatments (4019, UX-05), keyed by the API's series names. Energy = green,
// money = orange, cost = grey, derived lines = dashed ink.
export const SERIES_STYLES: Record<string, ISeriesStyle> = {
  "kWh Delivered": { borderColor: MF.energyMd, backgroundColor: MF.energySoft, borderWidth: 1.5 },
  Sessions: { borderColor: MF.slate, backgroundColor: MF.slate, borderWidth: 2.5 },
  Revenue: { borderColor: MF.orange, backgroundColor: MF.orange },
  "Energy Cost": { borderColor: "#D5D8DD", backgroundColor: MF.border, borderWidth: 1 },
  "Net Margin": { borderColor: MF.ink, backgroundColor: MF.ink, borderWidth: 2, borderDash: [6, 4] },
};

export const FALLBACK_SERIES_COLORS = [
  "#22c55e",
  "#64748b",
  "#f97316",
  "#0ea5e9",
];

export const NEXT_GEN_CHART_DATASET_DEFAULTS = {
  tension: 0.25,
  fill: false,
  pointRadius: 2,
  pointHoverRadius: 4,
} as const;

const MID_FI_TICKS = {
  color: MF.faint,
  font: { family: "Nunito", size: 10, weight: 700 },
};

export const NEXT_GEN_CHART_BASE_OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: "bottom" as const,
      align: "start" as const,
      labels: {
        usePointStyle: true,
        boxWidth: 10,
        // Datasets draw lines-over-bars via `order`, which would otherwise also reorder the legend.
        sort: (a: { datasetIndex?: number }, b: { datasetIndex?: number }) =>
          (a.datasetIndex ?? 0) - (b.datasetIndex ?? 0),
        color: MF.sub,
        font: { family: "Nunito", size: 11, weight: 700 },
      },
    },
  },
};

/** Axis styling shared by every NextGen chart: faint Nunito ticks, light horizontal grid only. */
export const NEXT_GEN_AXIS_STYLE = {
  ticks: MID_FI_TICKS,
  title: { color: MF.faint, font: { family: "Nunito", size: 10, weight: 700 } },
  grid: { color: MF.border },
  border: { display: false },
};
